import { useContext, useEffect, useState, Fragment } from "react";
import { Button } from "react-bootstrap";
import { MdContentCopy } from "react-icons/md";

import ListPage from "../../../shared/components/list-page/list-page";
import { IColumn, ITableRowData } from "../../../shared/components/normal-table/normal-table";
import SimpleModal from "../../../shared/components/simple-modal/simple-modal";
import Spinner from "../../../shared/components/spinner/spinner";
import Tooltip from "../../../shared/components/tooltip/tooltip";
import { roleWrite, roleAdmin } from "../../../shared/constants/user-roles";
import AuthContext from "../../../shared/context/auth-context";
import useHttp from "../../../shared/hooks/use-http";
import { getAllData, deleteMultiple } from "../../../shared/utils/api";
import { validateLoadingStatusNew } from "../../../shared/utils/utils";
import "./run-status.scss";
import { CustomToast } from "@/shared/components/custom-toast/custom-toast";
import toast from "react-hot-toast";

export const resultsColumns: IColumn[] = [
  {
    key: "description",
    displayName: "Description",
    dataType: {
      type: "text",
    }
  },
  {
    key: "start_timestamp",
    displayName: "Start",
    dataType: {
      type: "text",
    }
  },
  {
    key: "end_timestamp",
    displayName: "End",
    dataType: {
      type: "text",
    }
  },
  {
    key: "job_type",
    displayName: "Run status type",
    dataType: {
      type: "text",
    }
  },
  {
    key: "status",
    displayName: "Status",
    dataType: {
      type: "text",
    }
  }
];

const RunStatus = () => {
  const [data, setData] = useState(undefined);
  const [unblockInput, setUnblockInput] = useState(false);
  const [modal, setModal] = useState("");

  const [sortedBy, setSortedBy] = useState("?order_by=start_timestamp desc");
  const authCtx = useContext(AuthContext);
  const { sendRequest: getSortBy, status: getSortByStatus, data: getSortByData, error: errorGetSortByData } = useHttp(getAllData, true, authCtx.token, undefined, "analytics");
  const { sendRequest: deleteMultipleRequest, status: allStatusDelete, data: loadedDataDelete, error: errorDelete } = useHttp(deleteMultiple, false, authCtx.token, undefined, "analytics");

  useEffect(() => {
    const rolesArray = authCtx.selectedTenant.roles;
    if (rolesArray.indexOf(roleWrite) !== -1 || rolesArray.indexOf(roleAdmin) !== -1) {
      setUnblockInput(true);
    }
  }, [authCtx.selectedTenant, authCtx.systemAdmin]);

  useEffect(() => {
    getSortBy("training_status", "?order_by=start_timestamp desc");
  }, [getSortBy]);

  useEffect(() => {
    if (getSortByStatus === "completed" && !errorGetSortByData) {
      setData(getSortByData);
    }
  }, [getSortByStatus]);

  useEffect(() => {
    if (allStatusDelete === "completed" && !errorDelete) {
      setData(loadedDataDelete);
    }
  }, [allStatusDelete]);

  const handleOnDelete = (ids: string[]) => {
    deleteMultipleRequest(`training_status${sortedBy}`, { ids });
  };

  const sortBy = (sortingQuery: string) => {
    getSortBy("training_status", `${sortingQuery}`);
    setSortedBy(sortingQuery);
  };

  const renderExtraColumns = (id: string) => {
    return (
      <Fragment>
        <td>
          <span>
            <span id={"nonClick"} onClick={() => setModal(id)} className="normalTable-rowButton">detailed description</span>
          </span>
        </td>
      </Fragment>
    );
  };

  const renderModalBody = () => {
    if (getSortByData) {
      const findMatchingRow = getSortByData.rows.find((row: ITableRowData) => modal === row.id);
      return (
        <div className="runStatus-detailedDescription">
          {findMatchingRow?.detailed_description ? findMatchingRow?.detailed_description : "No description to be displayed"}
        </div>
      );
    }
  };

  const renderModalSaveBtn = () => {
    if (getSortByData) {
      const findMatchingRow = getSortByData.rows.find((row: ITableRowData) => modal === row.id);
      return (
        <Tooltip content={"Copy"} direction="top" delay={350} >
          <Button
            disabled={findMatchingRow?.detailed_description ? false : true}
            onClick={() => {
              if (findMatchingRow?.detailed_description) {
                navigator.clipboard.writeText(findMatchingRow.detailed_description)
                  .then(() => {
                    toast((t) => (
                      <CustomToast
                        t={t}
                        type="success"
                        message="Copied to clipboard!"
                      />
                    ));
                  })
                  .catch(() => {
                    toast((t) => (
                      <CustomToast
                        t={t}
                        type="error"
                        message="Failed to copy to clipboard"
                      />
                    ));
                  });
              }
            }}
            className="popup-action">
            <MdContentCopy />
          </Button>
        </Tooltip>
      );
    }
  };

  return (
    <div className="runStatus">
      <SimpleModal
        modalBody={renderModalBody()}
        saveButton={renderModalSaveBtn()}
        mode={"Detailed description"}
        handleModalClosed={() => setModal("")}
        handleSubmit={() => console.log("save")}
        show={modal === "" ? false : true}
      />
      {validateLoadingStatusNew([allStatusDelete, getSortByStatus]) && <Spinner />}
      {
        <ListPage
          title={"Run status"}
          sortBy={sortBy}
          defaultSortCol={"start_timestamp"}
          tooltipTxt={"Run status overview"}
          columns={resultsColumns}
          unblockInput={unblockInput}
          dataUrl={"/analytics/run-status"}
          pageMode={"nonEditable"}
          handleOnDelete={handleOnDelete}
          fetchedData={data}
          allStatus={getSortByStatus}
          hideButtons={["add"]}
          allStatusDelete={allStatusDelete}
          renderExtraColumns={renderExtraColumns}
        />
      }
    </div>
  );
};

export default RunStatus;
